import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { useToggle } from "react-use";
import { ListBox } from "./ListBox";
import { ArrowDown } from "./icons";
import { useComponentVisible } from "@hooks/index";
import { NEWEST, RATING_ASC, RATING_DESC } from "./constants";
import styles from "./styles/sort.module.css";

export function Sort({ handleSort, sortBy }) {
  const { t } = useTranslation("reviews");
  const { ref } = useComponentVisible(() => toggle(false));
  const [showPanel, toggle] = useToggle(false);

  function sort(value) {
    toggle();
    handleSort(value);
  }

  const buttonStyles = `
  ${styles.button}
  ${showPanel ? styles.upArrow : ""}
`;

  return (
    <div className={styles.container} ref={ref}>
      <button className={buttonStyles} onClick={toggle}>
        {t(sortBy)}
        <ArrowDown />
      </button>
      <ListBox
        description="sort"
        descriptionText={`sort reviews by ${NEWEST}, ${RATING_DESC}, ${RATING_ASC}`}
        showPanel={showPanel}
        sortValues={[NEWEST, RATING_DESC, RATING_ASC]}
        setSortBy={sort}
        sortBy={sortBy}
      />
    </div>
  );
}

Sort.propTypes = {};
